import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'reducers';
import { Constants } from 'utils';
import { Redirect, useLocation } from 'react-router-dom';

// Punto de entrada neutral para links externos (ej. email marketing):
// /#/memberships?pay=true
// No sabemos si quien entra es cliente o abogado, ni si tiene sesión
// iniciada, así que resolvemos eso aquí y reenviamos a la pantalla de
// membresías correcta, conservando el query string (?pay=true, etc.).
const RedirectMemberships = () => {
  const user = useSelector((state: RootState) => state.user);
  const location = useLocation();

  if (!user) {
    const next = encodeURIComponent('/memberships' + location.search);
    return <Redirect to={{ pathname: '/login', search: `?next=${next}` }} />;
  }

  switch (user?.level_id) {
    case Constants.LEVELS.LAWYER:
      return <Redirect to={{ pathname: '/lawyer/memberships', search: location.search }} />;

    case Constants.LEVELS.CLIENT:
      return <Redirect to={{ pathname: '/client/memberships', search: location.search }} />;

    default:
      // Admin/moderador u otros niveles no tienen pantalla de membresías.
      return <Redirect to='/' />;
  }
};

export default RedirectMemberships;
